import styled from 'styled-components';
import { Container, DisplayContainer } from './Common.styled';

// Portal Container - extends Container with portal-specific height
export const PortalContainer = styled(Container)`
  height: calc(100% - 3.5% - 100px - 185px);
`;

// Portal Container Display - extends DisplayContainer with portal-specific styling
export const PortalContainerDisplay = styled(DisplayContainer)`
  position: relative;
  margin: 20px auto;
  overflow: hidden;
  width: 1200px;
  height: 900px;
  max-width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 40px;
  
  /*  Glassmorphism Styling - Optimized for TV */
  background: ${(props) => props.theme.colors.glassBackground};
  backdrop-filter: ${(props) => props.theme.effects.backdropBlurLight};
  border: 1px solid ${(props) => props.theme.colors.glassOverlay};
  border-radius: ${(props) => props.theme.effects.borderRadiusLarge};
  color: ${(props) => props.theme.colors.textPrimary};
  transition: ${(props) => props.theme.effects.transitionMedium}; /* Simplified for TV */
  will-change: transform;
  
  /* Glow Effect - REMOVED for TV performance */
  /* &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: ${(props) => props.theme.colors?.glowGradient || 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.6), transparent)'};
    border-radius: ${(props) => props.theme.effects?.borderRadiusLarge || '24px'} ${(props) => props.theme.effects?.borderRadiusLarge || '24px'} 0 0;
    animation: shimmer 3s ease-in-out infinite;
  }
  
  @keyframes shimmer {
    0%, 100% { transform: translateX(-100%); }
    50% { transform: translateX(100%); }
  } */
  
  /* Hover Effects - Optimized for TV */
  &:hover {
    transform: translateY(-2px); /* Reduced from -5px for better performance */
  }
  
  /* Text Styling */
  > div:first-child {
    font-size: 1.4rem;
    font-weight: 600;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 20px;
    padding: 20px;
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    color: ${(props) => props.theme.colors.textPrimary};
    
    &:hover {
      transform: scale(1.02);
      color: ${(props) => props.theme.colors.textPrimary};
    }
  }
  
  /* Content Layout */
  .portal-content-layout {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 30px;
    width: 100%;
    height: 100%;
  }
  
  /* Image Container Styling */
  .portal-image-align {
    flex: 0 0 45%;
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
    overflow: hidden;
    
    padding: 15px;
    
    &:hover {
      transform: scale(1.02); /* Reduced from 1.05 for better performance */
    }
    
    img {
      border-radius: ${(props) => props.theme.effects.borderRadiusSmall};
      transition: ${(props) => props.theme.effects.transitionMedium}; /* Simplified for TV */
      
      &:hover {
        transform: scale(1.05); /* Reduced from 1.1 for better performance */
      }
    }
  }
  
  /* Description Styling */
  .portal-description {
    flex: 1;
    padding: 20px;
    border-radius: ${(props) => props.theme.effects.borderRadiusMedium};
   
    &:hover {
      transform: translateY(-2px); /* Reduced from -3px for better performance */
    }
    
    p {
      font-size: 1.2rem;
      line-height: 1.6;
      color: ${(props) => props.theme.colors.textPrimary};
      /* text-shadow removed for TV performance */
      margin: 0;
      text-align: left;
    }
  }
`; 